import React from 'react';
import dbee from '../../../../dbee';
import { AuthDataProvider } from '../';
import { ServiceProvider } from '../../../../service';

const DB_NAME = 'mockLogin';
const DB_PROP = 'userId';

function goToLoginPage(path, redirectTo) {
	redirectTo = redirectTo || window.location.href;
	window.location.href = `${path}?r=${encodeURIComponent(redirectTo)}`;
}

const services = ({config:{path}={}}) => ({
	Logout:(_, { setResult }) => {
		const db = dbee(DB_NAME, {saveDelay:0});
		db.clear();
		window.location.reload();
		setResult({});
	},
	Login: ({ userId }, { setResult }) => {
		if(!userId) {
			goToLoginPage(path, '/');
			setResult(true);
			return;
		}
		let urlParams = new URLSearchParams(window.location.search);
		const db = dbee(DB_NAME, {saveDelay:0});
		db.set(DB_PROP, userId);

		if(urlParams.has('r')) {
			window.location.href= decodeURIComponent(urlParams.get('r'));
		} else {
			window.location.href= "/";
		}
		setResult({userId});
	}
});

export default function Authenticator({children, enforce, path, data}) {
	const db = dbee(DB_NAME);
	if(enforce && !db.get(DB_PROP)) {
		goToLoginPage(path);
		return null;
	}
	return (
		<ServiceProvider config={{path}} services={services}>
			<AuthDataProvider value={{authenticator:'mock', ...data}}>{children}</AuthDataProvider>
		</ServiceProvider>
	);
}